module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_omiya-ae9cb845c2f44409ab27d30c56bf029d.jpg";